import { NavigationRoute } from 'fabscale-app/routes/base/-base-navigation-route';
import { RootNavigations } from 'fabscale-app/models/default-navigation-configuration';

export default class ReportsIndexRoute extends NavigationRoute {
  protected rootRoute: RootNavigations = 'reports';
}
